/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceStandardAssessmentSetStateRequest {
    getFixupPrototypeFunction() { return ComplianceStandardAssessmentSetStateRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceStandardAssessmentSetStateRequest>): ComplianceStandardAssessmentSetStateRequest {
        let obj = Object.assign(new ComplianceStandardAssessmentSetStateRequest(), model);
        ComplianceStandardAssessmentSetStateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceStandardAssessmentSetStateRequest>): ComplianceStandardAssessmentSetStateRequest {
        if (!model) return null;
        return ComplianceStandardAssessmentSetStateRequest.newInstance(<ComplianceStandardAssessmentSetStateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceStandardAssessmentSetStateRequest) {
        if (!obj) return;

        models.ComplianceStandardAssessmentSetStateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceStandardAssessmentSetStateRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceStandardAssessmentSetStateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Assessment job number
     */
    assessment_job_number: string;

}
